import { AdSet } from '../../entities/ad-set';
import { IntegrationInterface } from '../../interfaces/components/integrations/IntegrationInterface';
import { BrowserObjectModel } from '../browser-object-model';
import { ApplicationContext } from '../context/application.context';
import { Injectable } from '../dependency-injection/decorators';

@Injectable()
export class UserMetricIntegration implements IntegrationInterface {
  public constructor (
    private readonly browserObjectModel: BrowserObjectModel,
    private readonly applicationContext: ApplicationContext,
  ) {
  }

  public async run (adSet: AdSet): Promise<void> {
    if (!this.supports(adSet)) {
      return;
    }

    const scriptUrl = adSet.getSettings().getUserMetricsScriptUrl();

    if (!scriptUrl) {
      return;
    }

    const script = this.browserObjectModel.getDocument().createElement('script');
    script.src = scriptUrl;
    script.type = 'text/javascript';
    script.async = true;
    script.onload = (): void => {
      const cls = this.browserObjectModel.getWindow()['MetricsManager'];

      if (!cls) {
        return;
      }

      new cls(this.applicationContext.getSessionId());
    }

    this.browserObjectModel.getDocument().getElementsByTagName('head')[ 0 ].appendChild(script);
  }

  public supports (adSet: AdSet): boolean {
    return (adSet.getSettings().getUserMetricsScriptUrl()?.trim()?.length ?? 0) > 0;
  }
}
